import Vue from 'vue';

import {
  BIcon,
  BIconCart3,
  BIconCheck2,
  BIconPlus,
  BIconDash,
  BIconStarFill,
  BIconStarHalf,
  BIconChevronDown,
  BIconList,
  BIconX,
  BNavbar,
  BBreadcrumb,
  BNavbarBrand,
  BNavbarToggle,
  BNavbarNav,
  BNavItem,
  BNavItemDropdown,
  BCollapse,
  BDropdown,
  BSidebar,
  BForm,
  BFormGroup,
  BFormDatepicker,
  BFormSelect,
  BFormInput,
  BFormCheckbox,
  BFormSelectOption,
  BFormRadio,
  BFormTextarea,
  BDropdownItem,
  BCarousel,
  BCarouselSlide,
  BModal,
  BAlert,
  BImgLazy,
  BTooltip,
  VBToggle
} from 'bootstrap-vue';

Vue.component('BIcon', BIcon);
Vue.component('BIconCart3', BIconCart3);
Vue.component('BIconCheck2', BIconCheck2);
Vue.component('BIconPlus', BIconPlus);
Vue.component('BIconDash', BIconDash);
Vue.component('BIconStarFill', BIconStarFill);
Vue.component('BIconStarHalf', BIconStarHalf);
Vue.component('BIconChevronDown', BIconChevronDown);
Vue.component('BIconList', BIconList);
Vue.component('BIconX', BIconX);
Vue.component('BNavbar', BNavbar);
Vue.component('BBreadcrumb', BBreadcrumb);
Vue.component('BNavbarBrand', BNavbarBrand);
Vue.component('BNavbarToggle', BNavbarToggle);
Vue.component('BNavbarNav', BNavbarNav);
Vue.component('BNavItem', BNavItem);
Vue.component('BNavItemDropdown', BNavItemDropdown);
Vue.component('BCollapse', BCollapse);
Vue.component('BDropdown', BDropdown);
Vue.component('BSidebar', BSidebar);
Vue.component('BForm', BForm);
Vue.component('BFormGroup', BFormGroup);
Vue.component('BFormDatepicker', BFormDatepicker);
Vue.component('BFormSelect', BFormSelect);
Vue.component('BFormInput', BFormInput);
Vue.component('BFormCheckbox', BFormCheckbox);
Vue.component('BFormSelectOption', BFormSelectOption);
Vue.component('BFormRadio', BFormRadio);
Vue.component('BFormTextarea', BFormTextarea);
Vue.component('BDropdownItem', BDropdownItem);
Vue.component('BCarousel', BCarousel);
Vue.component('BCarouselSlide', BCarouselSlide);
Vue.component('BModal', BModal);
Vue.component('BAlert', BAlert);
Vue.component('BImgLazy', BImgLazy);
Vue.component('BTooltip', BTooltip);

Vue.directive('BToggle', VBToggle);
